// extracted by mini-css-extract-plugin
module.exports = {"root":"actions_root__kQfvd","spinnerContainer":"actions_spinnerContainer__2z92V"};